<template>
	<div class="tpl chat-list">
		<div class="chat-list-header">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">聊天（10）</mt-tab-item>
				<mt-tab-item id="2">通知</mt-tab-item>
			</mt-navbar>
			<router-link :to="{name:'friend-list'}" class="friend-list-btn">
				<img src="../../assets/img/chats/ic_chat_nav_myfriend@2x.png" />
			</router-link>
		</div>
		<mt-search v-model="value" cancel-text="取消" placeholder="搜索" @click.native="searchFriend">
			<mt-cell v-for="(item,index) in result" :key="index" :title="item.title" :value="item.value">
			</mt-cell>
		</mt-search>

		<!-- tab-container -->
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1" class="load-more-wrap">
				<mt-loadmore :top-method="refreshChatsList" :bottom-method="loadMoreChatsList" :auto-fill="false" ref="loadmore">
				  <mt-cell-swipe v-for="(item,index) in chatList" :key="index" 
					:right="[
						{content: '置顶',style: { background: '#d2d2d2', color: '#fff'},handler: () => deleteItem('delete')},
						{content: '标记已读',style: { background: '#01aef0', color: '#fff'},handler: () => deleteItem('delete')},
						{content: '删除',style: { background: '#ff6161', color: '#fff'},handler: () => deleteItem('delete')},
						
					]">
					<div class="chat-list-item" @click="goToChat()">
						<div class="item-avatar"><img :src="item.avatar" alt="" /></div>
						<div class="item-text">
							<p class="item-name">{{item.nickname}}</p>
							<p class="item-content">{{item.content}}</p>
						</div>
						<div class="item-other">
							<p class="item-time">{{item.time}}</p>
							<mt-badge class="item-num" type="error">{{item.num}}</mt-badge>
						</div>
					</div>
					
				</mt-cell-swipe>
				<div class="no-content" v-if="chatList.length<1">
					<img src="../../assets/img/default/bg_img_empty@2x.png"/>
					<p>没有聊天内容哦~</p>
				</div>
				</mt-loadmore>
				
			</mt-tab-container-item>
			<mt-tab-container-item id="2" class="load-more-wrap">
				<div class="no-content">
					<img src="../../assets/img/default/bg_img_hi@2x.png"/>
					<p>打开鱼水缘App查看更多消息通知哦~</p>
				</div>
			</mt-tab-container-item>
		</mt-tab-container>
	</div>
</template>

<script>
	export default {
		name: "chats",
		data() {
			return {
				uid:"",
				selected: "1",
				value: "",
				result: [],
				chatList: [
//					{
//						uid:"1",
//						avatar:require("../../assets/img/test/user_man.png"),
//						nickname:"zhou",
//						content:"今天天气挺好的，适合去爬山...",
//						time:"10:30",
//						num:"9"
//					},
				]
			}
		},
		created(){
			this.uid = this.$store.state.UserId;
			this.$store.commit("changeTabChoosed","chats");
			this.$store.commit("changeTabBarShow",true);
		},
		methods:{
			deleteItem(n){
				console.log(n)
			},
			goToChat(){
				this.$router.push({
					name:"chatting"
				})
			},
			searchFriend(){
				this.$router.push({
					name:"add-friend"
				})
			},
			refreshChatsList(){
				if(this.chatList.length<10){
					this.$refs.loadmore.onTopLoaded();
					return;
				}
				var _this = this;
				console.log("loadtop");
				setTimeout(function(){
					_this.$refs.loadmore.onTopLoaded();
				},2000)
				
			},
			loadMoreChatsList(){
				if(this.chatList.length<10){
					this.$refs.loadmore.onBottomLoaded();
					return;
				}
				var _this = this;
				console.log("loadbottom");
				setTimeout(function(){
					_this.$refs.loadmore.onBottomLoaded();
				},2000)
				
			},
		}
	}
</script>

<style scoped>
	.chat-list {
		padding-top: 6rem;
	}
	
	.chat-list-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 0.5rem;
		position: fixed;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		background: #fff;
	}
	
	.mint-navbar {
		width: 50%;
	}
	
	>>>.mint-navbar .mint-tab-item {
		box-sizing: border-box;
	}
	
	>>>.mint-tab-item .mint-tab-item-label {
		/*transition: 300ms;*/
	}
	
	>>>.mint-tab-item.is-selected .mint-tab-item-label {
		font-size: 1rem;
		font-weight: bold;
		color: #5415f9;
	}
	
	>>>.mint-navbar .mint-tab-item.is-selected {
		border-bottom: 0;
	}
	
	.friend-list-btn img {
		width: 1.5rem;
	}
	
	.mint-search {
		position: fixed;
		width: 100%;
		height: auto;
		top: 2.9rem;
		left: 0;
		z-index: 10;
	}
	
	>>>.mint-searchbar {
		background-color: #fff;
	}
	
	>>>.mint-searchbar-inner {
		background: rgba(40, 40, 40, .12);
		border-radius: 1rem;
		padding: 0 0.8rem;
	}
	
	>>>.mint-searchbar-inner .mintui-search {
		color: #7644FA;
		font-size: 1rem;
	}
	>>>.mint-searchbar-cancel{
		color: #7644FA;
		font-size: 0.8rem;
	}
	
	>>>.mint-searchbar-inner input {
		background: none;
		padding: 0 0.5rem;
	}
	>>>.mint-cell-value{
		width: 100%;
	}
	>>>.mint-cell-swipe:first-of-type{
		border-top: 1px solid #f3f3f3;
	}
	>>>.mint-cell-swipe{
		border-bottom: 1px solid #f3f3f3;
	}
	>>>.mint-cell-wrapper:active{
		background: #efe7fe;
	}
	.chat-list-item{
		width: 100%;
		display: flex;
    	justify-content: space-between;
    	padding: 0.5rem 0;
	}
	.chat-list-item .item-avatar{
	    width: 3rem;
	    height: 3rem;
	    overflow: hidden;
	    border-radius: 50%;
	}
	.chat-list-item .item-avatar img{
		width: 100%;
	}
	.chat-list-item .item-text{
		flex: 1;
		padding: 0 0.5rem;
	}
	.chat-list-item .item-name{
		font-size: 1rem;
		line-height: 1.8rem;
		color: #282828;
		font-weight: bold;
	}
	.chat-list-item .item-content{
		font-size: 0.8rem;
		color: #9e9e9e;
		line-height: 1.2rem;
	}
	.chat-list-item .item-other{
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.chat-list-item .item-time{
		font-size: 0.65rem;
	}
	>>>.mint-cell-swipe-button{
		line-height: 4rem;
		padding: 0 1rem;
	}
	>>>.mint-badge.is-size-normal{
		font-size: 0.65rem;
	}
	
	.load-more-wrap{
		overflow: scroll;
		height: calc(100vh - 9.2rem);
	}
	
	
</style>


// WEBPACK FOOTER //
// src/components/Chats/Chats.vue